<script lang="ts">
import IconComponent from '@/components/atoms/Icon.vue';
import { IPanelState } from '@/components/molecules/panel/panel-state.interface';
import { AccessibilityHandler, IconName } from 'webshop-modules';
import { Component, Vue, Emit, Prop } from 'vue-facing-decorator';

@Component({
    components: { IconComponent },
    name: 'Panel'
})
export default class Panel extends Vue {
    @Prop() 
    public state!: IPanelState;

    @Emit() 
    public toggle(): IPanelState {
        const clone: IPanelState = JSON.parse(JSON.stringify(this.state)) as IPanelState;
        clone.isContentShown = !clone.isContentShown;

        return clone;
    }

    public readonly iconName: typeof IconName = IconName;

    public get isTitleTranslation(): boolean {
        return this.state.title !== undefined && typeof this.state.title !== 'string';
    }

    public handleKeyPress(event: KeyboardEvent) {
        AccessibilityHandler.handleActionWithCallback(event, this.toggle);
    }
}
</script>

<template>
    <div v-bind:class="{ '-has-no-border': state.hasNoBorder }" class="m-panel">
        <div v-on:click="toggle"
            v-bind:class="{
                '-can-toggle': state.isClosable,
                '-is-open': state.isContentShown,
                '-is-empty': state.hasNoHeader,
            }"
            @keydown="handleKeyPress($event)"
            class="m-panel__head" data-js="panel-header"
            tabindex="0">
            <template v-if="!state.hasNoHeader">
                <h2 v-if="isTitleTranslation" v-translate="state.title"></h2>
                <h2 v-else>{{ state.title }}</h2>
            </template>

            <template v-if="state.isClosable && !state.hasNoHeader">
                <IconComponent :icon-id="iconName.Arrow"/>
            </template>
        </div>

        <div class="m-panel__body" v-if="state.isContentShown">
            <slot></slot>
        </div>
    </div>
</template>
